import { UseRecordsOptions } from "../../api/useRecords";
import { RecordContextType } from "../../components/record/Record";

export const staffWeeklyHoursOptions = {
    fieldsToRemove: {
        fieldTypesToRemove: ["alias"],
    },
    createRelatedParams: (params: RecordContextType | undefined) => createStaffWeeklyHoursParams(params),
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "staff_agreement",
                disabled: true,
            }
        ],

    },
} as UseRecordsOptions;

const createStaffWeeklyHoursParams = async (recordContext: RecordContextType | undefined) => {
    if (!recordContext?.item) return;
    if (recordContext.entity === "staff_agreements") return `[staff_agreements][id]=${recordContext.item.id}`;
};
